import { useEffect } from 'react'
import type { TransitionPage as TransitionPageType } from '@/content/quiz/types'

interface TransitionPageProps {
  page: TransitionPageType
  onComplete: () => void
}

export function TransitionPage({ page, onComplete }: TransitionPageProps) {
  useEffect(() => {
    if (page.durationMs) {
      const t = setTimeout(onComplete, page.durationMs)
      return () => clearTimeout(t)
    }
  }, [page.durationMs, onComplete])

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] py-12">
      <div className="animate-pulse flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-slate-300 border-t-slate-900 rounded-full animate-spin" />
        <p className="text-slate-600">{page.message || 'Loading...'}</p>
      </div>
    </div>
  )
}
